type AppEventMap = {
  'auth:unauthorized': { reason?: string }
}

class AppEvents {
  private target = new EventTarget()

  on<K extends keyof AppEventMap>(type: K, handler: (detail: AppEventMap[K]) => void) {
    const listener = (event: Event) => {
      const custom = event as CustomEvent<AppEventMap[K]>
      handler(custom.detail)
    }
    this.target.addEventListener(type as string, listener)
    return () => this.target.removeEventListener(type as string, listener)
  }

  emit<K extends keyof AppEventMap>(type: K, detail: AppEventMap[K]) {
    this.target.dispatchEvent(new CustomEvent(type as string, { detail }))
  }
}

export const appEvents = new AppEvents()

